import { SupportedLocales } from './locale.constants';
import { isKeyOfObject } from 'utils/deep-object-freeze/deep-object-freeze';

export const cleanLangParam = (param: string | null) => {
  if (!param) return null;
  let cleanedParam = param.replace(/\s+/g, ''); // remove whitespace
  cleanedParam = cleanedParam.replace('-', '_'); // replace hyphens with underscores
  // our apps use underscore separator internally
  // but we support lang param in the BCP 47 format
  // https://en.wikipedia.org/wiki/IETF_language_tag

  return cleanedParam;
};

export const getLocaleFromParam = (
  langParam: string | null,
  redirectURIParam: string | null
) => {
  const langParamCleaned = cleanLangParam(langParam);

  if (langParamCleaned && isKeyOfObject(langParamCleaned, SupportedLocales)) {
    return SupportedLocales[langParamCleaned];
  } else if (redirectURIParam !== null) {
    const langParamFromRedirectURI = redirectURIParam.substring(
      redirectURIParam.indexOf('lang=') + 5,
      redirectURIParam.length
    );

    const cleanedLangParamFromRedirectURI = cleanLangParam(
      langParamFromRedirectURI
    );

    if (
      cleanedLangParamFromRedirectURI &&
      isKeyOfObject(cleanedLangParamFromRedirectURI, SupportedLocales)
    ) {
      return SupportedLocales[cleanedLangParamFromRedirectURI];
    }
  }
};

export const setCSSDirection = (isRTL = false) => {
  document
    .getElementsByTagName('HTML')[0]
    ?.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
};
